import { LOCALE_ID, NgModule } from '@angular/core';
import {
  CommonModule,
  CurrencyPipe,
  registerLocaleData,
} from '@angular/common';
import { CommercialAgreementsRoutingModule } from './commercial-agreements-routing-module';
import { DataTablesModule } from 'angular-datatables';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommercialAgreementsComponent } from './commercial-agreements.component';
import {
  NgbDropdownModule,
  NgbOffcanvasModule,
  NgbPaginationModule,
  NgbTooltipModule,
  NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';
import { UploadComponent } from './modals/upload/upload.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MasterModule } from '../master/master.module';
import { UpdateComponent } from './modals/update/update.component';
import { CreateComponent } from './modals/create/create.component';
import localeEsCL from '@angular/common/locales/es-CL';
import { SapIdPipe } from 'src/app/shared/pipes/sap-id.pipe';
registerLocaleData(localeEsCL);

@NgModule({
  declarations: [
    CommercialAgreementsComponent,
    UploadComponent,
    UpdateComponent,
    CreateComponent,
  ],
  imports: [
    CommonModule,
    CommercialAgreementsRoutingModule,
    SharedModule,
    DataTablesModule,
    NgbDropdownModule,
    ReactiveFormsModule,
    MasterModule,
    NgbTooltipModule,
    NgbOffcanvasModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
  ],
  providers: [
    CurrencyPipe,
    { provide: LOCALE_ID, useValue: 'es-CL' },
    SapIdPipe,
  ],
})
export class CommercialAgreementsModule {}
